import React from 'react'

import { Inquiry } from '../../assets/ts/data/inquiry/inquiry'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
import { handleScroll } from '../../assets/ts/general/general'
import NO_RESULTS from '../../utils/constants/no-results'
import ExportToCSVButton from '../buttons/export-to-csv-btn'
import CustomerDashboardInquiresTableHead from './customer-dashboard-inquiries-table-head'
import CustomerDashboardInquiresTableRow from './customer-dashboard-inquiries-table-row'
import './table.css'

type Props = {
  count: string
  countNumber : number
  deleteItems?: (selectedItem: string) => Promise<void>
  getAllSelectedRecords: () => Promise<Inquiry[]>
  inquiries: Inquiry[]
  onBottomScrollReached?: () => void
  onTopScrollReached?: () => void
  title: string
}

const CustomerDashboardInquiresTable = ({
  count,
  countNumber,
  deleteItems,
  getAllSelectedRecords,
  inquiries,
  onBottomScrollReached,
  onTopScrollReached,
  title,
}: Props) => {
  return (
    <>
      <div className='d-flex py-2 border-bottom1 align-items-center tableheader'>
        <h2
          aria-describedby='tableheading'
          className='m-0 p-0 align-items-sm-center poppins-semibold font-13 text-uppercase title-color'
          id='tableheading'
          tabIndex={0}
        >
          {defaultToEmptyString(title)}{' '}
          <span className='badge border-radius3 px-2 py-1 whitetext poppins-semibold bgcolor-primary'>
            {defaultToEmptyString(count)}
          </span>
        </h2>
       { countNumber > 0 && <ExportToCSVButton
          fetchDataFunc={getAllSelectedRecords}
          pageType='CustomerDashboard/Inquiries'
        />}
      </div>

      <div
        className='w-100 overflow-auto px-1 inquiriestable'
        onScroll={(e) => handleScroll(e, onTopScrollReached, onBottomScrollReached)}
      >
        <table className='table-borderless table-dis w-100 sticky-top second-column last-column table-rowgap'>
          <CustomerDashboardInquiresTableHead title={title} />
          <tbody>
            {inquiries.map((i) => (
              <CustomerDashboardInquiresTableRow
                deleteItems={deleteItems}
                inquiry={i}
                key={i.InquiryGUID}
                title={title}
              />
            ))}
          </tbody>
        </table>
        {inquiries.length < 1 && <NO_RESULTS />}
      </div>
    </>
  )
}
export default CustomerDashboardInquiresTable
